export default __webpack_public_path__ + "static/media/Aryan.f3069e67.jpeg";